import { createLogger } from '@wkda/funnel-modules';

/**
 * @typedef {import('@wkda/funnel-modules').ModulesLogger} ModulesLogger
 * */

/**
 * @param {import("@wkda/internal-types").IBaseAppConfig} config
 * @param {import("@wkda/elastic-rum").RumLogger} [rumLogger]
 * @return {import("@wkda/funnel-modules").ModulesLogger}
 * */
export function createClientLogger(config, rumLogger) {
  if (!rumLogger) {
    return createLogger(config);
  }

  /**@satisfies {ModulesLogger} */
  return {
    info(_ref) {
      let {
        message,
        meta
      } = _ref;
      rumLogger.log(meta.name, meta.scope, message);
    },
    error(_ref2) {
      let {
        error
      } = _ref2;
      if (error instanceof Error) {
        rumLogger.error(error);
      }
    },
    log(logRecord) {
      rumLogger.log(logRecord.meta?.name, logRecord.meta?.scope, logRecord.message);
    }
  };
}